import router from '@/router';
import axios, { AxiosResponse } from 'axios';
import { LoginInput } from './auth.model';

export async function whoAmI(): Promise<any>{
    //let res = null;
    return await axios.get(process.env.VUE_APP_CJ_API_URL + `/whoAmI`)
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error whoAmI in !',err);
            return {error : err};
        });
}

export async function login(loginData: LoginInput): Promise<any> {
    return axios.post(process.env.VUE_APP_CJ_API_URL + `/auth/login`,
            loginData)
        .then(async resp => {
            const token = 'Bearer ' + resp.data.token
            localStorage.setItem('user-token', token) // store the token in localstorage
            axios.defaults.headers.common['Authorization'] = token;
            const res = await whoAmI();
            localStorage.setItem('user-role', res.data.role) // store the token in localstorage
            localStorage.setItem('user-id', res.data.id) // store the token in localstorage
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error login in !',err);
            delete axios.defaults.headers.common['Authorization'];
            localStorage.removeItem('user-token');
            localStorage.removeItem('user-role');
            localStorage.removeItem('user-id');
            return {error : err};
        });
}

export async function logout(): Promise<any> {
    delete axios.defaults.headers.common['Authorization'];
    localStorage.removeItem('user-token'); // if the request fails, remove any possible user token if possible
    localStorage.removeItem('user-role');
    localStorage.removeItem('user-id');
}


export async function loginRedirection(){
    if (! localStorage.getItem('user-token')){
        router.push('/login');
    }
}

export function interceptResponses(){
    axios.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if ((err.request.status === 401 && err.config && !err.config.__isRetryRequest)) {
            logout();
            loginRedirection();
          }
          throw err;
        });
      });
}